var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseVueElementLoading',_vm._b({},'BaseVueElementLoading',_vm.$attrs,false),[_c('AnimatedLogoLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }